module.exports = "pegasus/assets/themelp1/small/7.png";